import { parseCardAwsJsonField } from './parse-card-awsjson.util';

/**
 * Card `presentation` may be a plain object or an AppSync `AWSJSON` string at runtime.
 */
export function parseChartPresentationInput(value: unknown): unknown {
	return parseCardAwsJsonField(value);
}
